<div class="row mt-3 mb-3">
  <div class="col-12">
    <button (click)="adicionar()" #btnAdicionar class="btn btn-sm btn-outline-primary">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy">
  <thead>
    <tr>
      <th style="width: 60%" scope="col">Unidade Fornecimento</th>
      <th style="width: 10%" scope="col">Ativo</th>
      <th style="width: 10%" scope="col">Bec</th>
      <th style="width: 20%" scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <td *ngIf="!item.editavel" style="width: 60%">{{item.unidade.nome}}</td>
      <td *ngIf="!item.editavel" style="width: 10%">
        <span *ngIf="item.ativo" class="badge badge-success">Ativo</span>
        <span *ngIf="!item.ativo" class="badge badge-danger">Inativo</span>
      </td>
      <td *ngIf="!item.editavel" style="width: 10%">
        <span *ngIf="item.bec" class="badge badge-primary ml-2">Bec</span>
      </td>

      <td *ngIf="item.editavel" style="width: 60%">
        <p-autoComplete id="rec" [(ngModel)]="itemAtual.unidade" [forceSelection]="true" [autoHighlight]="true"
          [ngModelOptions]="{standalone: true}" [field]="unidadeAutoComplete.conversor"
          [suggestions]="unidadeAutoComplete.lista" (completeMethod)="unidadeAutoComplete.filtrar($event)"
          inputStyleClass="form-control form-control-sm" minLength="2" [style]="{ width: '100%' }">
          <ng-template let-unidade pTemplate="item">
            {{unidade.nome}}
          </ng-template>
        </p-autoComplete>
      </td>
      <td *ngIf="item.editavel" style="width: 10%">
        <div class="checkbox checbox-switch switch-success">
          <label>
            <input type="checkbox" [(ngModel)]="itemAtual.ativo"
              [ngModelOptions]="{standalone: true}" /><span></span>Ativo
          </label>
        </div>
      </td>
      <td *ngIf="item.editavel" style="width: 10%">
        <div class="checkbox checbox-switch switch-primary">
          <label>
            <input type="checkbox" [(ngModel)]="itemAtual.bec" [ngModelOptions]="{standalone: true}" /><span></span>Bec
          </label>
        </div>
      </td>

      <td class="text-right" style="width: 20%">
        <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="editar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>